<div class="section container-fluid pb-3">
    <div class="row justify-content-center">
        <div class="col-11 col-xl-12">
            <div class="row pb-2">
                <div class="col-sm-6 col-md-4 col-lg-3 col-xl-2 mt-3" *ngFor="let midwife of midwifes; let i = index"
                    [ngClass]="{'offset-xl-1': i % 5 == 0}">
                    <app-profile-card [midwife]="midwife"></app-profile-card>
                </div>
            </div>
        </div>
        <div class="col-11 col-xl-12 text-center my-3" *ngIf="loading">
            <div class="spinner-border loader" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div class="col-6 col-md-4 col-lg-3 col-xl-2 mt-3 mb-3" *ngIf="!loading && midwifes.length && showLoadMore">
            <button class="btn btn-theme btn-block btn-lg" (click)="getMidwifeList()">Load More</button>
        </div>
        <div class="col-11 col-xl-12 text-center my-3" *ngIf="!loading && !midwifes.length">
            <h5>No Midwife Found !!</h5>
        </div>
    </div>
</div>